// Message interpolation, kept free of React so it is trivially testable.
//
// interpolate: "{name}" → value. A single pass over the template, so a
// substituted value containing "{b}" is NOT re-expanded (that would let
// translated copy inject other keys).
//
// splitRich: describes a message with {slot} placeholders as an ordered list of
// text/slot parts. The React layer maps slots to elements. This is why message
// strings never need to contain markup — see the audit in scripts/audit/i18n-keys.cjs.

const PLACEHOLDER = /\{(\w+)\}/g;

/**
 * @param {string} template
 * @param {Record<string, string|number>} vars
 * @returns {string}
 */
export function interpolate(template, vars = {}) {
    if (!template) return "";
    const v = vars ?? {};
    return String(template).replace(PLACEHOLDER, (match, key) =>
        Object.prototype.hasOwnProperty.call(v, key) ? String(v[key]) : match
    );
}

/**
 * @param {string} template
 * @param {string[]} slotKeys placeholders to treat as slots; others stay literal
 * @returns {Array<{type: "text"|"slot", value: string}>}
 */
export function splitRich(template, slotKeys = []) {
    if (!template) return [];
    const parts = [];
    let last = 0;
    for (const match of String(template).matchAll(PLACEHOLDER)) {
        const key = match[1];
        if (!slotKeys.includes(key)) continue;
        if (match.index > last) parts.push({ type: "text", value: template.slice(last, match.index) });
        parts.push({ type: "slot", value: key });
        last = match.index + match[0].length;
    }
    if (last < template.length) parts.push({ type: "text", value: template.slice(last) });
    return parts;
}
